import { HebDateUtil } from '../Util/HebDateUtil';
import { HDate } from '@hebcal/core';
import { TfilaParts } from './ShiurTfila';



const OmerDays = [
	["[]", "[]"],
	["הַיּוֹם יוֹם אֶחָד לָעוֹמֶר", "חסד שבחסד"],
	["הַיּוֹם שְׁנֵי יָמִים לָעוֹמֶר", "גבורה שבחסד"],
	["הַיּוֹם שְׁלשָׁה יָמִים לָעוֹמֶר", "תפארת שבחסד"],
	["הַיּוֹם אַרְבָּעָה יָמִים לָעוֹמֶר", "נצח שבחסד"],
	["הַיּוֹם חֲמִשָּׁה יָמִים לָעוֹמֶר", "הוד שבחסד"],
	["הַיּוֹם שִׁשָּׁה יָמִים לָעוֹמֶר", "יסוד שבחסד"],
	["הַיּוֹם שִׁבְעָה יָמִים שֶׁהֵם שָׁבוּעַ אֶחָד לָעוֹמֶר", "מלכות שבחסד"],
	["הַיּוֹם שְׁמוֹנָה יָמִים שֶׁהֵם שָׁבוּעַ אֶחָד וְיוֹם אֶחָד לָעוֹמֶר", "חסד שבגבורה"],
	["הַיּוֹם תִּשְׁעָה יָמִים שֶׁהֵם שָׁבוּעַ אֶחָד וּשְׁנֵי יָמִים לָעוֹמֶר", "גבורה שבגבורה"],
	["הַיּוֹם עֲשָׂרָה יָמִים שֶׁהֵם שָׁבוּעַ אֶחָד וּשְׁלשָׁה יָמִים לָעוֹמֶר", "תפארת שבגבורה"],
	["הַיּוֹם אַחַד עָשָׂר יוֹם שֶׁהֵם שָׁבוּעַ אֶחָד וְאַרְבָּעָה יָמִים לָעוֹמֶר", "נצח שבגבורה"],
	["הַיּוֹם שְׁנֵים עָשָׂר יוֹם שֶׁהֵם שָׁבוּעַ אֶחָד וַחֲמִשָּׁה יָמִים לָעוֹמֶר", "הוד שבגבורה"],
	["הַיּוֹם שְׁלשָׁה עָשָׂר יוֹם שֶׁהֵם שָׁבוּעַ אֶחָד וְשִׁשָּׁה יָמִים לָעוֹמֶר", "יסוד שבגבורה"],
	["הַיּוֹם אַרְבָּעָה עָשָׂר יוֹם שֶׁהֵם שְׁנֵי שָׁבוּעוֹת לָעוֹמֶר", "מלכות שבגבורה"],
	["הַיּוֹם חֲמִשָּׁה עָשָׂר יוֹם שֶׁהֵם שְׁנֵי שָׁבוּעוֹת וְיוֹם אֶחָד לָעוֹמֶר", "חסד שבתפארת"],
	["הַיּוֹם שִׁשָּׁה עָשָׂר יוֹם שֶׁהֵם שְׁנֵי שָׁבוּעוֹת וּשְׁנֵי יָמִים לָעוֹמֶר", "גבורה שבתפארת"],
	["הַיּוֹם שִׁבְעָה עָשָׂר יוֹם שֶׁהֵם שְׁנֵי שָׁבוּעוֹת וּשְׁלשָׁה יָמִים לָעוֹמֶר", "תפארת שבתפארת"],
	["הַיּוֹם שְׁמוֹנָה עָשָׂר יוֹם שֶׁהֵם שְׁנֵי שָׁבוּעוֹת וְאַרְבָּעָה יָמִים לָעוֹמֶר", "נצח שבתפארת"],
	["הַיּוֹם תִּשְׁעָה עָשָׂר יוֹם שֶׁהֵם שְׁנֵי שָׁבוּעוֹת וַחֲמִשָּׁה יָמִים לָעוֹמֶר", "הוד שבתפארת"],
	["הַיּוֹם עֶשְׂרִים יוֹם שֶׁהֵם שְׁנֵי שָׁבוּעוֹת וְשִׁשָּׁה יָמִים לָעוֹמֶר", "יסוד שבתפארת"],
	["הַיּוֹם אֶחָד וְעֶשְׂרִים יוֹם שֶׁהֵם שְׁלשָׁה שָׁבוּעוֹת לָעוֹמֶר", "מלכות שבתפארת"],
	["הַיּוֹם שְׁנַיִם וְעֶשְׂרִים יוֹם שֶׁהֵם שְׁלשָׁה שָׁבוּעוֹת וְיוֹם אֶחָד לָעוֹמֶר", "חסד שבנצח"],
	["הַיּוֹם שְׁלשָׁה וְעֶשְׂרִים יוֹם שֶׁהֵם שְׁלשָׁה שָׁבוּעוֹת וּשְׁנֵי יָמִים לָעוֹמֶר", "גבורה שבנצח"],
	["הַיּוֹם אַרְבָּעָה וְעֶשְׂרִים יוֹם שֶׁהֵם שְׁלשָׁה שָׁבוּעוֹת וּשְׁלשָׁה יָמִים לָעוֹמֶר", "תפארת שבנצח"],
	["הַיּוֹם חֲמִשָּׁה וְעֶשְׂרִים יוֹם שֶׁהֵם שְׁלשָׁה שָׁבוּעוֹת וְאַרְבָּעָה יָמִים לָעוֹמֶר", "נצח שבנצח"],
	["הַיּוֹם שִׁשָּׁה וְעֶשְׂרִים יוֹם שֶׁהֵם שְׁלשָׁה שָׁבוּעוֹת וַחֲמִשָּׁה יָמִים לָעוֹמֶר", "הוד שבנצח"],
	["הַיּוֹם שִׁבְעָה וְעֶשְׂרִים יוֹם שֶׁהֵם שְׁלשָׁה שָׁבוּעוֹת וְשִׁשָּׁה יָמִים לָעוֹמֶר", "יסוד שבנצח"],
	["הַיּוֹם שְׁמוֹנָה וְעֶשְׂרִים יוֹם שֶׁהֵם אַרְבָּעָה שָׁבוּעוֹת לָעוֹמֶר", "מלכות שבנצח"],
	["הַיּוֹם תִּשְׁעָה וְעֶשְׂרִים יוֹם שֶׁהֵם אַרְבָּעָה שָׁבוּעוֹת וְיוֹם אֶחָד לָעוֹמֶר", "חסד שבהוד"],
	["הַיּוֹם שְׁלשִׁים יוֹם שֶׁהֵם אַרְבָּעָה שָׁבוּעוֹת וּשְׁנֵי יָמִים לָעוֹמֶר", "גבורה שבהוד"],
	["הַיּוֹם אֶחָד וּשְׁלשִׁים יוֹם שֶׁהֵם אַרְבָּעָה שָׁבוּעוֹת וּשְׁלשָׁה יָמִים לָעוֹמֶר", "תפארת שבהוד"],
	["הַיּוֹם שְׁנַיִם וּשְׁלשִׁים יוֹם שֶׁהֵם אַרְבָּעָה שָׁבוּעוֹת וְאַרְבָּעָה יָמִים לָעוֹמֶר", "נצח שבהוד"],
	["הַיּוֹם שְׁלשָׁה וּשְׁלשִׁים יוֹם שֶׁהֵם אַרְבָּעָה שָׁבוּעוֹת וַחֲמִשָּׁה יָמִים לָעוֹמֶר", "הוד שבהוד"],
	["הַיּוֹם אַרְבָּעָה וּשְׁלשִׁים יוֹם שֶׁהֵם אַרְבָּעָה שָׁבוּעוֹת וְשִׁשָּׁה יָמִים לָעוֹמֶר", "יסוד שבהוד"],
	["הַיּוֹם חֲמִשָּׁה וּשְׁלשִׁים יוֹם שֶׁהֵם חֲמִשָּׁה שָׁבוּעוֹת לָעוֹמֶר", "מלכות שבהוד"],
	["הַיּוֹם שִׁשָּׁה וּשְׁלשִׁים יוֹם שֶׁהֵם חֲמִשָּׁה שָׁבוּעוֹת וְיוֹם אֶחָד לָעוֹמֶר", "חסד שביסוד"],
	["הַיּוֹם שִׁבְעָה וּשְׁלשִׁים יוֹם שֶׁהֵם חֲמִשָּׁה שָׁבוּעוֹת וּשְׁנֵי יָמִים לָעוֹמֶר", "גבורה שביסוד"],
	["הַיּוֹם שְׁמוֹנָה וּשְׁלשִׁים יוֹם שֶׁהֵם חֲמִשָּׁה שָׁבוּעוֹת וּשְׁלשָׁה יָמִים לָעוֹמֶר", "תפארת שביסוד"],
	["הַיּוֹם תִּשְׁעָה וּשְׁלשִׁים יוֹם שֶׁהֵם חֲמִשָּׁה שָׁבוּעוֹת וְאַרְבָּעָה יָמִים לָעוֹמֶר", "נצח שביסוד"],
	["הַיּוֹם אַרְבָּעִים יוֹם שֶׁהֵם חֲמִשָּׁה שָׁבוּעוֹת וַחֲמִשָּׁה יָמִים לָעוֹמֶר", "הוד שביסוד"],
	["הַיּוֹם אֶחָד וְאַרְבָּעִים יוֹם שֶׁהֵם חֲמִשָּׁה שָׁבוּעוֹת וְשִׁשָּׁה יָמִים לָעוֹמֶר", "יסוד שביסוד"],
	["הַיּוֹם שְׁנַיִם וְאַרְבָּעִים יוֹם שֶׁהֵם שִׁשָּׁה שָׁבוּעוֹת לָעוֹמֶר", "מלכות שביסוד"],
	["הַיּוֹם שְׁלשָׁה וְאַרְבָּעִים יוֹם שֶׁהֵם שִׁשָּׁה שָׁבוּעוֹת וְיוֹם אֶחָד לָעוֹמֶר", "חסד שבמלכות"],
	["הַיּוֹם אַרְבָּעָה וְאַרְבָּעִים יוֹם שֶׁהֵם שִׁשָּׁה שָׁבוּעוֹת וּשְׁנֵי יָמִים לָעוֹמֶר", "גבורה שבמלכות"],
	["הַיּוֹם חֲמִשָּׁה וְאַרְבָּעִים יוֹם שֶׁהֵם שִׁשָּׁה שָׁבוּעוֹת וּשְׁלֹשָׁה יָמִים לָעוֹמֶר", "תפארת שבמלכות"],
	["הַיּוֹם שִׁשָּׁה וְאַרְבָּעִים יוֹם שֶׁהֵם שִׁשָּׁה שָׁבוּעוֹת וְאַרְבָּעָה יָמִים לָעוֹמֶר", "נצח שבמלכות"],
	["הַיּוֹם שִׁבְעָה וְאַרְבָּעִים יוֹם שֶׁהֵם שִׁשָּׁה שָׁבוּעוֹת וַחֲמִשָּׁה יָמִים לָעוֹמֶר", "הוד שבמלכות"],
	["הַיּוֹם שְׁמוֹנָה וְאַרְבָּעִים יוֹם שֶׁהֵם שִׁשָּׁה שָׁבוּעוֹת וְשִׁשָּׁה יָמִים לָעוֹמֶר", "יסוד שבמלכות"],
	["הַיּוֹם תִּשְׁעָה וְאַרְבָּעִים יוֹם שֶׁהֵם שִׁבְעָה שָׁבוּעוֹת לָעוֹמֶר", "מלכות שבמלכות"]
];

export function GetSfiratOmer(gregDate) {
	const hDate = new HDate(gregDate);

	return <>
				<div className='general'>
					<center className='shiur-title'><b>ספירת העומר</b></center>

					<p>בָּרוּךְ אַתָּה יְיָ אֱלֹהֵינוּ מֶלֶךְ הָעוֹלָם. אֲשֶׁר קִדְּשָׁנוּ בְּמִצְוֹתָיו וְצִוָּנוּ עַל סְפִירַת הָעוֹמֶר:</p>

					<center>{ OmerDays[HebDateUtil.getDayOfOmer(hDate)][0] }</center>
					
					<p>הָרַחֲמָן הוּא יַחֲזִיר לָנוּ עֲבוֹדַת בֵּית הַמִּקְדָּשׁ לִמְקוֹמָהּ, בִּמְהֵרָה בְּיָמֵינוּ אָמֵן סֶלָה:</p>
					<p>
						לַמְנַצֵּחַ בִּנְגִינוֹת מִזְמוֹר שִׁיר: אֱלֹּהִים יְחָנֵּנוּ וִיבָרְכֵנוּ יָאֵר פָּנָיו אִתָּנוּ סֶלָה:
						לָדַעַת בָּאָרֶץ דַּרְכֶּךָ בְּכָל גּוֹיִם יְשׁוּעָתֶךָ: יוֹדוּךָ עַמִּים אֱלֹּהִים יוֹדוּךָ עַמִּים כֻּלָּם:
						יִשְׂמְחוּ וִירַנְּנוּ לְאֻמִּים כִּי תִשְׁפֹּט עַמִּים מִישֹׁר וּלְאֻמִּים בָּאָרֶץ תַּנְחֵם סֶלָה:
						יוֹדוּךָ עַמִּים אֱלֹּהִים יוֹדוּךָ עַמִּים כֻּלָּם: אֶרֶץ נָתְנָה יְבוּלָהּ יְבָרְכֵנוּ אֱלֹּהִים אֱלֹּהֵינוּ:
						יְבָרְכֵנוּ אֱלֹּהִים וְּיִּרְאוּ אֹתוֹ כָּל  אַפְסֵי אָרֶץ:
					</p>


					{ /* אנא בכח */ }
					{ TfilaParts.AnaBekoach() }
					
					<p>
						רִבּוֹנוֹ שֶׁל עוֹלָם, אַתָּה צִוִּיתָנוּ עַל יְדֵי משֶׁה עַבְדֶּךָ לִסְפּוֹר סְפִירַת הָעוֹמֶר כְּדֵי לְטַהֲרֵנוּ
						מִקְלִפּוֹתֵינוּ וּמִטּוּמְאוֹתֵינוּ, כְּמוֹ שֶׁכָּתַבְתָּ בְּתוֹרָתֶךָ: וּסְפַרְתֶּם לָכֶם מִמָּחֳרַת הַשַּׁבָּת מִיוֹם
						הֲבִיאֲכֶם אֶת עוֹמֶר הַתְּנוּפָה שֶׁבַע שַׁבָּתוֹת תְּמִימוֹת תִּהְיֶינָה, עַד מִמָּחֳרַת הַשַּׁבָּת
						הַשְּׁבִיעִית תִּסְפְּרוּ חֲמִשִּׁים יוֹם, כְּדֵי שֶׁיִּטָּהֲרוּ נַפְשׁוֹת עַמְּךָ יִשְׂרָאֵל מִזֻּהֲמָתָם, וּבְכֵן
						יְהִי רָצוֹן מִלְּפָנֶיךָ יְיָ אֱלֹקֵינוּ וֵאלֹהֵי אֲבוֹתֵינוּ שֶׁבִּזְכוּת סְפִירַת הָעוֹמֶר שֶׁסָּפַרְתִּי הַיּוֹם,
						יְתֻקַּן מַה שֶׁפָּגַמְתִּי בִּסְפִירָה

						<small> { OmerDays[HebDateUtil.getDayOfOmer(hDate)][1] } </small>

						וְאֶטָּהֵר וְאֶתְקַדֵּשׁ בִּקְדֻשָּׁה שֶׁל מַעְלָה, וְעַל יְדֵי זֶה יֻשְׁפַּע שֶׁפַע רַב בְּכָל הָעוֹלָמוֹת
						וּלְתַקֵּן אֶת נַפְשׁוֹתֵינוּ וְרוּחוֹתֵינוּ, וְנִשְׁמוֹתֵינוּ מִכָּל סִיג וּפְגַם וּלְטַהֲרֵנוּ וּלְקַדְּשֵׁנוּ
						בִּקְדֻשָׁתְךָ הָעֶלְיוֹנָה, אָמֵן סֶלָה:
					</p>
				</div>
			</>;
};

export async function GetSO(gregDate) {
	return new Promise((myResolve, myReject) => {
		myResolve(
			GetSfiratOmer(gregDate)
		);
	});
};